import { defineStore } from 'pinia';
import useHttp from '~/lib/http';
import type { StatusAnnouncement } from '~/models/StatusAnnouncement';

const useStatusAnnouncementStore = defineStore('statusAnnouncement', {
    state: () => ({
        interval: null as NodeJS.Timeout | null,
        announcements: new Map<StatusAnnouncement['uuid'], StatusAnnouncement>(),
    }),
    actions: {
        mount() {
            this.interval = setInterval(this.getAnnouncements, 30 * 1000);
            this.getAnnouncements();
        },
        unmount() {
            if (this.interval) {
                clearInterval(this.interval);
                this.interval = null;
            }
        },
        async getAnnouncements() {
            return useHttp().get<StatusAnnouncement[]>('status').then(response => {
                const announcementsMap = new Map<StatusAnnouncement['uuid'], StatusAnnouncement>();

                response.forEach(announcement => {
                    announcementsMap.set(announcement.uuid, announcement);
                });

                this.announcements = announcementsMap;
            });
        },
    },
});

export default useStatusAnnouncementStore;

